import { environment, type Environment } from "../environment";

import legacyBaseRoutes from "./base-routes.legacy.json";
import landingzonesRoutes from "./base-routes.landingzones.json";

export type BaseRoutes = typeof legacyBaseRoutes | typeof landingzonesRoutes;

export function getRoutes(environment: Environment): BaseRoutes {
	switch (environment) {
		case "preprod":
		case "prod1":
		case "prod2":
			return landingzonesRoutes;
		default: {
			return legacyBaseRoutes;
		}
	}
}

export const baseRoutes: BaseRoutes = getRoutes(environment);
